import './Team.scss';

import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'atoms/button';
import Table from 'organisms/Table';
import { openDrawer } from 'store/reducers/ui';
import { teamColumns, teamColumnsOrder } from 'util/constants';

export default function Team() {
  const dispatch = useDispatch();
  const { groomers } = useSelector((state) => state.groomers);

  const onAddGroomer = () => {
    dispatch(openDrawer({ type: 'groomer-create' }));
  };

  return (
    <>
      <Helmet title="Team | PawCare" />
      <div className="w-100 flex-row">
        <div className="page-container team-page-container">
          <div className="flex-row justify-between team-page-container-header pb-20 pr-30 pl-30">
            <h1>Your team</h1>
            <Button text="+ New groomer" onClick={onAddGroomer} size="small" />
          </div>
          <div className="team-page-container-table-container">
            <Table
              items={groomers}
              isLoading={false}
              onClickItem={() => {}}
              columns={teamColumns}
              columnsOrder={teamColumnsOrder}
            />
          </div>
        </div>
      </div>
    </>
  );
}
